<div class="panel-body " *ngIf="allegationUndisciplined===undefined">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Allegation Result
      </div>
      <div class="panel-body ">
        No Allegation Result information available for this allegation.
      </div>
  </div>
</div>
<div class="panel-body " *ngIf="allegationUndisciplined!==undefined">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
   <div class="panel-title">
       Allegation Result
     </div>
   <div class="panel-body ">
       <div class="col-md-6 panel panel-default">
         <div class="panel panel-default "  *ngIf="allegationUndisciplined.getAdjudicationDate() !== ''">
         <div class="panel-title">
             Adjudication Date
         </div>
         <div class="panel-body">
             {{allegationUndisciplined.getAdjudicationDate() | date:'MM/dd/yyyy'}}
         </div>
         </div>
         <div class="panel panel-default " *ngIf="allegationUndisciplined.getParents().length !==0">
         <div class="panel-title">
               Parent/Guardian/Custodian Assigned
         </div>
         <div class="panel-body" *ngFor="let parent of allegationUndisciplined.getParents(); let al = index">
               {{parent.getPartyName()+ ' (' + parent.getRelationship() + ')'}}
         </div>
         </div>
       </div>
       <div class="col-sm-6 panel panel-default ">
         <div class="panel panel-default " *ngIf="allegationUndisciplined.getAdjudicationEoDate() !== ''">
         <div class="panel-title">
           Adjudication EO Date
         </div>
         <div class="panel-body">
             {{allegationUndisciplined.getAdjudicationEoDate() | date:'MM/dd/yyyy'}}
         </div>
         </div>
         <div class="panel panel-default" *ngIf="allegationUndisciplined.getAttorneys().length !== 0">
           <div class="panel-title">
             Attorneys Representing
           </div>
           <div class="panel-body" *ngFor="let attorneyName of allegationUndisciplined.getAttorneys();" >
            {{attorneyName}} <br>
           </div>  
         </div>
       </div>
       </div>
       <div class="panel panel-default" *ngIf="allegationUndisciplined.getOtherAllegations().length !=0">
        <div class="panel-title">
          Other Allegations Included On Order
        </div>
        <div class="panel-body">
            <div class="row table-responsive">
                <table id="allegations-table" class="table table-condensed table-striped">
                    <thead>
                        <tr>
                            <th id="V122c">
                              <span class="field-code ">V122c json='allegations.pleadingType'</span>
                              Pleading Type <br> 
                              <span class="field-code ">V122c json='allegations.clockDate'</span>
                              And Clock Date
                            </th>
                            <th id="V121c">
                              <span class="field-code ">V121c json='allegations.allegation'</span>
                                Allegation <br>
                                <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                Offense Date
                              </th>
                             </tr>
                    </thead>
                    <tbody  *ngFor="let otherAllegation of allegationUndisciplined.getOtherAllegations()let i = index;">                            
                      <tr >
                       <td id="{{'juvenile-caseDetails-allegationUndisciplined-' + i + '-pleadingType'}}">
                         {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                         {{otherAllegation.getOtherPleadingDate() | date:'MM/dd/yyyy'}} {{otherAllegation.getOtherPleadingTime()}}</td>
                       <td id="{{'juvenile-caseDetails-allegationUndisciplined-' + i + '-allegationDescription'}}">
                         {{otherAllegation.getOtherAllegationDescription()}} <br>        
                         {{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
                     </tr>    
                    </tbody>
                </table>
            </div>
        </div>
        </div>
     <div class="panel panel-default" *ngIf="allegationUndisciplined.getProvenInd() !== ''">
           <div class="panel-title">
             Findings
           </div>
          <div class="panel-body">
             <B>Based on the evidence presented:</B>
             <ul style="list-style-type:disc">
                 <div *ngIf="allegationUndisciplined.getProvenInd() === 'NP'" >
                    <li>the allegations have not been proven by clear and convincing evidence.</li>
                 </div>
                 <div *ngIf="allegationUndisciplined.getProvenInd() === 'PR'" >
                   <li> the allegations have been proven by clear and convincing evidence.</li>
                   <span *ngIf="allegationUndisciplined.getFactsNotes() !== ''">
                    <ul style="list-style-type:disc">
                    {{allegationUndisciplined.getFactsNotes()}}
                    </ul></span>
                 </div>
             </ul>
          </div>
         </div>
   <div class="panel panel-default" *ngIf="allegationUndisciplined.getCourtJurisdictionInd() !== ''">
           <div class="panel-title">
             Conclusions of Law
           </div>
           <div class="panel-body">
             <B>The Court concludes as a matter of law that:</B>
             <ul style="list-style-type:disc">
                 <div *ngIf="allegationUndisciplined.getCourtJurisdictionInd() === 'IJ'" >
                   <li> the juvenile is within the juvenile jurisdiction of the Court as an undisciplined juvenile.</li>
                 </div>
                 <div *ngIf="allegationUndisciplined.getCourtJurisdictionInd() === 'NJ'" >
                   <li> the juvenile is not within the juvenile jurisdiction of the Court as an undisciplined juvenile.</li>
                 </div>
             </ul>
           </div>
       </div>
   <div class="panel panel-default" *ngIf="allegationUndisciplined.getOrderedInd() !== ''">
           <div class="panel-title">
             Order
           </div>
           <div class="panel-body">
             <B>It is therefore ORDERED that the case:</B>
             <ul style="list-style-type:disc">
                 <div *ngIf="allegationUndisciplined.getOrderedInd() === 'dismissed'" >
                   <li> be dismissed.</li>
                 </div>
                 <div *ngIf="allegationUndisciplined.getOrderedInd() === 'proceed'" >
                   <li> proceed to disposition.</li>
                 </div>
         <div *ngIf="allegationUndisciplined.getOrderedInd() === 'transfer'" >
                   <li> be transferred to {{allegationUndisciplined.getTransCounty()}} County for Disposition.</li>
                 </div>
         <div *ngIf="allegationUndisciplined.getOrderedInd() === 'continued'" >
                   <li> be continued for disposition until {{allegationUndisciplined.getContinuedDate()}}</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="allegationUndisciplined.getConditionsInd() === 'ON'" >
                        <li>under the following conditions:</li>
                        <span *ngIf="allegationUndisciplined.getOrdersNotes() !== ''">
                        <ul style="list-style-type:disc">
                        <li>{{allegationUndisciplined.getOrdersNotes()}}</li>
                        </ul></span>
                      </div>
                    </ul>
                 </div>
             </ul>
           </div>
       </div>
 </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/allegation-undisciplined/allegation-undisciplined.component.html